export const ContentSizeClasses = {
  SIZE_XS: ['wf-h-6', 'wf-w-6'],
  SIZE_SM: ['wf-h-8', 'wf-w-8'],
  SIZE_LG: ['wf-h-10', 'wf-w-10'],
  SIZE_2X: ['wf-h-12', 'wf-w-12'],
  SIZE_3X: ['wf-h-16', 'wf-w-16'],
  SIZE_5X: ['wf-h-24', 'wf-w-24'],
  SIZE_7X: ['wf-h-32', 'wf-w-32'],
  SIZE_10X: ['wf-h-48', 'wf-w-48']
}
